import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export type accessTokenProps = {
  accessToken : string
}

const initialState: accessTokenProps = { accessToken:'' }	// 초기값

export const authInfoSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
  },
  
});

export const {setAccessToken} = authInfoSlice.actions;

// slice를 내보냄
export default authInfoSlice.reducer;